import React, {useEffect, useState} from 'react';
import amudaryo_sxema from "../../../../../icons/amudaryo_sxema.png";
import axios from "axios";
import {header} from "../../../../../components/api/Header";
import { getEnv } from "../../../../../lib/env";

function Page2({date}) {
    const [data, setData] = useState()
    useEffect(()=>{
        const fetchData = async () => {
            const res = await axios.get(getEnv('REACT_APP_BASE_URL')+"/v1/republik/amudaryo/linemap?date="+date,header())
                .catch(e=>{
                    console.log("Xato",e)
                    alert("Serverga ulanishda xatolik")
                })
            if(res){
                setData(res.data)
            }
        }
        fetchData()
    },[date])

    return (
        <div className="card statistic-card w-100">
            <div className="container-fluid amu-sxema">
                {
                    data ?
                    <>
                        <span className="span1">Do'stlik k-li <br/> {data[171]?data[171]['suvi']:'-'} m<sup>3</sup>/s</span>        {/*Do'stlik k-li	171*/}
                        <span className="span2">Arnasoy k-li<br/> {data[174]?data[174]['suvi']:'-'} m<sup>3</sup>/s</span>        {/*Anasoy k-li	174*/}
                        <span className="span3">O'ng qirg'oq kanali<br/> {data[677]?data[677]['suvi']:'-'} m<sup>3</sup>/s</span>        {/*O'ng qirg'oq kanali	677*/}
                        <span className="span4">Qipchoq g/p<br/> H {data[715]?data[715]['suvi']:'-'} sm</span>                     {/*Qipchoq g/p	715*/}
                        <span className="span5">Q {data[716]?data[716]['suvi']:'-'} m<sup>3</sup>/s</span>        {/*Qipchoq g/p	716*/}
                        <span className="span6">N/s QQR<br/> {data[163]?data[163]['suvi']:'-'} m<sup>3</sup>/s</span>        {/*N/s QQR	163*/}
                        <span className="span7"> {data[176]?data[176]['suvi']:'-'} m<sup>3</sup>/s</span>        {/*taxitosh daryoga tashlama	176*/}
                        <span className="span8"> {data[676]?data[676]['suvi']:'-'} m<sup>3</sup>/s</span>        {/*tuyamoyin daryoga tashlama	676*/}
                        <span className="span9">GRESS<br/> {data[175]?data[175]['suvi']:'-'} m<sup>3</sup>/s</span>        {/*GRESS	175*/}
                        <span className="span10">N/s Xorazm<br/> {data[184]?data[184]['suvi']:'-'} m<sup>3</sup>/s</span>      {/*N/s Xorazm	184*/}
                        <span className="span11">Jumaboy k-li<br/> {data[720]?data[720]['suvi']:'-'} m<sup>3</sup>/s</span>      {/*Jumaboy k-li	720*/}
                        <span className="span12">Paralelniy va <br/>Suenli k-lari<br/> {add(data[183]?data[183]['suvi']:0,data[172]?data[172]['suvi']:0)} m<sup>3</sup>/s</span>      {/*Paralelniy va Suenli k-lari	172+183*/}
                        <span className="span13">Pitnak k-li<br/> {data[680]?data[680]['suvi']:'-'} m<sup>3</sup>/s</span>      {/*Pitnak k-li	680*/}
                        <span className="span14">Chap qirg'oq k-li<br/> {data[678]?data[678]['suvi']:'-'} m<sup>3</sup>/s</span>      {/*Chap qirg'oq k-li	678*/}
                        <span className="span15">Turkmandaryo k-li<br/> {data[679]?data[679]['suvi']:'-'} m<sup>3</sup>/s</span>      {/*Turkmandaryo k-li	679*/}
                        <span className="span16">Xonyap k-li<br/> {data[721]?data[721]['suvi']:'-'} m<sup>3</sup>/s</span>      {/*Xonyap k-li	721*/}
                        <span className="span17">Qlichboy k-li<br/> {data[706]?data[706]['suvi']:'-'} m<sup>3</sup>/s</span>      {/*Qlichboy k-li	706*/}
                        <span className="span18">{data[674]?data[674]['suvi']:'-'} mln.m<sup>3</sup></span>    {/*Tuyamo'yin suv omborli	674*/}
                        <span className="span19">Darganata g/p<br/> H {data[667]?data[667]['suvi']:'-'} sm</span>                 {/*Darganata g/p	667*/}
                        <span className="span20"> Q {data[668]?data[668]['suvi']:'-'} m<sup>3</sup>/s</span>    {/*Darganata g/p	668*/}
                        <span className="span21">Charjou g/p<br/> H {data[672]?data[672]['suvi']:'-'} sm</span>                 {/*Charjou g/p	672*/}
                        <span className="span22"> {data[673]?data[673]['suvi']:'-'} m<sup>3</sup>/s</span>      {/*tuyamoyin kelishi	673*/}
                        <span className="span23">ABMK<br/> {data[110]?data[110]['suvi']:'-'} m<sup>3</sup>/s</span>      {/*ABMK	110*/}
                        <span className="span24">KMK<br/> {data[72]?data[72]['suvi']:'-'} m<sup>3</sup>/s</span>      {/*KMK	72*/}
                        <span className="span25">Amu-Zang<br/> {data[5]?data[5]['suvi']:'-'} m<sup>3</sup>/s</span>      {/*Amu-Zang	5*/}
                        <span className="span26">Kerki g/p<br/> H {data[650]?data[650]['suvi']:'-'} sm</span>                 {/*Kerki g/p	650*/}
                        <span className="span27"> Q {data[651]?data[651]['suvi']:'-'} m<sup>3</sup>/s</span>    {/*Kerki g/p	651*/}
                        <span className="span28">Termiz g/p<br/> {data[645]?data[645]['suvi']:'-'} sm</span>                   {/*Termiz g/p	645*/}
                        <span className="span29">Lebab viloyati<br/> {data[654]?data[654]['suvi']:'-'} m<sup>3</sup>/s</span>      {/*Lebab viloyati	654*/}
                        <span className="span30">Qoraqamu k-li<br/> {data[648]?data[648]['suvi']:'-'} m<sup>3</sup>/s</span>      {/*Qoraqamu k-li	648*/}
                        <span className="span31">Tuyamo'yin <br/> suv ombori</span>
                    </>
                    :null
                }
                <img src={amudaryo_sxema} alt="404" className="suv-omborlari-img" />
            </div>
        </div>
    );
}

export default Page2;

const add = (a,b) => {
    if(!a || typeof(a) == 'undefined'){
        a = 0
    }
    if(!b || typeof(b) == 'undefined'){
        b = 0
    }
}
